// Autogenerated file
export const legalPersonFlagsEnum = {
    Main: "Main",
};
export const legalPersonFlags = [
    { label: "Основная организация", value: "Main", intValue: 1 },
];
